export const VIEW_AS_PANEL = {
    HIDE_MSRP: "hide-msrp",
    HIDE_WHOLESALE: "hide-wholesale",
    VIEW_AS_GUEST: "view-as-guest",
    CLEAR: "clear-view-as",
};
